var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{attrs:{"content":_vm.title,"open-delay":350,"disabled":_vm.isDisabled,"transition":"el-zoom-in-bottom","effect":"dark","placement":"top"}},[_c('div',{class:_vm.commandButtonClass,on:{"mousedown":function($event){$event.preventDefault();},"click":_vm.onClick}},[_c('span',{class:_vm.icon})])])
}
var staticRenderFns = []

export { render, staticRenderFns }